import React from "react";

import { SupLoader, SupText } from "@repo/core-ui";

export default function Web3CommonCartLoader() {
  return (
    <div className="flex h-screen w-full flex-col justify-center">
      <div className="flex flex-col items-center justify-center space-y-4">
        <SupLoader />
        <SupText variant="caption">Loading vaults data...</SupText>
      </div>
    </div>
  );
}
